import { AdministratorDto } from './AdministratorDto';
import { Media } from './MeidaDto';

export type BannerType = '홈 배너' | '상세 배너';
export type BannerContentCategoryType =
  | 'notice'
  | 'magazine'
  | 'donation'
  | 'entry';
export const bannerContentCategoryTypeKr: Record<
  BannerContentCategoryType,
  string
> = {
  notice: '공지사항',
  magazine: '매거진',
  donation: '기부하기',
  entry: '응모하기',
};
export type BannerContentType =
  | 'bannerAppPageConnection'
  | 'bannerContentConnection'
  | 'bannerExternalUrlConnection';

export class BannerDto {
  id: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  // 배너 타입 (홈, 상세)
  bannerType: BannerType;
  // 배너 제목
  bannerTitle: string;
  // 정렬 순서
  bannerOrderNumber: number;
  // 게시 시작
  bannerPostStartedAt: string;
  // 게시 끝
  bannerPostEndedAt: string;
  // 노출 여부
  bannerShowedYn: boolean;
  // 광고 여부
  bannerMarketingYn: boolean;
  // 홈 페이지 노출 여부
  bannerHomeShowedYn: boolean;
  // 기부하기 페이지 노출 여부
  bannerDonationShowedYn: boolean;
  // 커뮤니티 페이지 노출 여부
  bannerCommunityShowedYn: boolean;
  // 챌린지 페이지 노출 여부
  bannerChallengeShowedYn: boolean;
  // 배너 컨텐츠 타입 (내부 페이지, 상세 페이지, 외부 링크)
  bannerContentType: BannerContentType;
  // 등록 관리자
  administrator: AdministratorDto;
  // 배너 이미지
  bannerImage: Media;
  // 배너 컨텐츠 상세 타입
  bannerContentCategory: BannerContentCategoryType;
  // 배너 컨텐츠 페이지 타입
  bannerAppPageConnectionCategory?: string | null;
  // 배너 컨텐츠 페이지 타입 한글
  bannerAppPageConnectionCategoryKr: string;
  // 컨텐츠 제목
  contentTitle?: string | null;
  // 외부 링크
  bannerExternalUrl?: string | null;
  // 컨텐츠 상세 id
  bannerContentId?: number | null;
  // 클릭 수
  bannerViewHistoryCount: number;
  bannerContentCategoryKr?: string;
}

export interface BannerExternalUrlConnection {
  bannerExternalUrlConnectionContent: string;
}

// 유틸 함수
export const getConnectedContent = (data: BannerDto, isFull = true) => {
  let result = '';

  switch (data.bannerContentType) {
    case 'bannerAppPageConnection':
      result = '앱 내 화면';

      if (isFull) {
        result += `- ${data?.bannerAppPageConnectionCategoryKr}`;
      }

      break;
    case 'bannerContentConnection':
      result = '컨텐츠 상세 연결';
      if (isFull) {
        switch (data?.bannerContentCategory) {
          case 'notice':
            result += '- 공지사항';
            break;
          case 'magazine':
            result += '- 매거진';
            break;
          case 'donation':
            result += '- 기부하기';
            break;
          case 'entry':
            result += '- 응모하기';
            break;
          default:
            break;
        }
      }
      break;
    case 'bannerExternalUrlConnection':
      result = '외부 링크 연결';
      break;
    default:
      result = '-';
      break;
  }

  return result;
};

export const getConnectedContentDetail = (data: BannerDto) => {
  let result = '';

  switch (data.bannerContentType) {
    case 'bannerAppPageConnection':
      result = data?.bannerAppPageConnectionCategoryKr || '-';

      break;
    case 'bannerContentConnection':
      switch (data?.bannerContentCategory) {
        case 'notice':
          result = `[공지사항] ${data?.contentTitle}`;
          break;
        case 'magazine':
          result = `[매거진] ${data?.contentTitle}`;
          break;
        case 'donation':
          result = `[기부하기] ${data?.contentTitle}`;
          break;
        case 'entry':
          result = `[응모하기] ${data?.contentTitle}`;
          break;
        default:
          break;
      }

      break;
    case 'bannerExternalUrlConnection':
      result = data?.bannerExternalUrl || '';
      break;
    default:
      result = '-';
      break;
  }

  return result;
};
